export default {
      id: "video-event_other-usage",
      viewBox: "0 0 25 22",
      url: __webpack_public_path__ + "img/icons.svg#video-event_other",
      toString: function () {
        return this.url;
      }
    }